import React, {Component} from "react";
import {inject, observer} from "mobx-react";


import AkindaLogo from "../../assets/img/sa/akinda_logo.png";
import PhotoSelfie from "../../assets/img/sa/selfie_album_top.png";
import OkLogo from "../../assets/img/sa/ok.png";
import {toJS} from "mobx";

@inject('store')
@observer
class ConfirmUploadCalendar extends Component {
    constructor(props) {
        super(props);

        this.state = {


        }
        this.store = this.props.store.appState;
    };

    componentDidMount() {
        document.body.style.background = '#275f84';
    }

    render() {
        const DEFAULT_TEXT = toJS(this.store.DEFAULT_TEXT);
        return (
            <React.Fragment>
            <div className='main-div-calendar' >
                <div className='akinda-logo-calendar'>
                    <img className='img-akindalogo-calendar' src={AkindaLogo} alt='AkindaLogo'/>
                </div>
                <div className='calendar-wrapper-div'>
                    <div>
                        <img className='img-photoselfie' src={PhotoSelfie} alt='Selfie'/>
                    </div>
                    <div className={'introduction'}>
                        <img className='img-oklogo' src={OkLogo} width={'100%'} alt="ok"/>
                        <h2 className='complimenti'>
                            {DEFAULT_TEXT.compliments}
                        </h2>
                        <p className='para-comp'>{DEFAULT_TEXT.calendar_uploaded_ok}</p>
                    </div>
                </div>
                <div className='bottom-container '>
                    <p className='separator'/>
                </div>
            </div>
            </React.Fragment>
        )
    }
}


export default ConfirmUploadCalendar;


// WEBPACK FOOTER //
// ./src/views/Calendar/ConfirmUploadCalendar.jsx